export default __webpack_public_path__ + "static/media/logo-home.425ed925.png";